import { render, staticRenderFns } from "./addClassify.vue?vue&type=template&id=d3db45ce&scoped=true&"
import script from "./addClassify.vue?vue&type=script&lang=js&"
export * from "./addClassify.vue?vue&type=script&lang=js&"
import style0 from "./addClassify.vue?vue&type=style&index=0&id=d3db45ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3db45ce",
  null
  
)

export default component.exports